<template>
<div class="card-main">
  <div class="card-main-left">
    <HrTree @nodeClick="onHrTree"/>
  </div>
  <div class="card-main-right">
    <slot></slot>
  </div>
</div>
</template>

<script>
import HrTree from "../../../Personnel/components/HrTree";
export default {
  name: "CardLayout",
  components: {HrTree},
  methods:{
    onHrTree(e){
      this.$emit("onHrTree",e);
    }
  },
}
</script>

<style lang="scss" scoped>
.card-main{
  display: flex;
  flex-direction: row;
  width: calc( 100vw - 160px );
  //margin-top: 10px;
  margin-left: 10px;
  .card-main-left{
    border-right: 1px solid #d7d7d7;
  }
  .card-main-right{
    width: calc( 100vw - 160px - 280px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/components/CardLayout.vue